import { render, staticRenderFns } from "./modmain.vue?vue&type=template&id=4ff87255"
import script from "./modmain.vue?vue&type=script&lang=js"
export * from "./modmain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports